// import React, { useEffect, useState } from 'react';
// import { Button, Table, Container, Row, Col } from 'reactstrap'; // Using Bootstrap components for layout
// import Layout from '../component/layout/Layout';
// import { useCart } from '../context/CardContext';
// import { CREATE_ORDER, VERIFY_PAYMENT } from '../helper/url_helper';
// import axios from 'axios';
// import { toast } from 'react-toastify';
// import { useNavigate } from 'react-router-dom';


// const Cart = () => {
//     const { cart, total, removeFromCart, updateQuantity, emptyCart } = useCart();
//     const [loading, setLoading] = useState(false);
//     const navigate = useNavigate();

//     const handleQuantityChange = (courseId, quantity) => {
//         updateQuantity(courseId, quantity);
//     };

//     const handleCheckout = async () => {
//         setLoading(true);

//         // Load Razorpay script if not already loaded
//         const loadRazorpayScript = () => {
//             return new Promise((resolve, reject) => {
//                 if (window.Razorpay) {
//                     resolve(true); // Razorpay already loaded
//                     return;
//                 }
//                 const script = document.createElement("script");
//                 script.src = "https://checkout.razorpay.com/v1/checkout.js";
//                 script.onload = () => resolve(true);
//                 script.onerror = () => reject(new Error("Razorpay SDK failed to load"));
//                 document.body.appendChild(script);
//             });
//         };

//         try {
//             // Step 1: Load Razorpay script
//             await loadRazorpayScript();

//             const amount = total;
//             // Step 2: Create an order on the backend
//             const response = await axios.post(CREATE_ORDER, { amount });

//             // Log the data received from the backend
//             console.log("Order Data:", response);
//             const student = JSON.parse(localStorage.getItem("student"));
//             const data = response.data;
//             // Step 3: Define Razorpay checkout options
//             const options = {
//                 key: "rzp_live_1BBogpUA2x4OjV",
//                 amount: data.amount, // Amount in paise
//                 currency: "INR",
//                 name: "Amass Skill Ventures",
//                 description: "Payment for courses",
//                 order_id: data.id, // Order ID from backend
//                 handler: async (response) => {
//                     // Step 4: Handle successful payment
//                     const studentId = JSON.parse(localStorage.getItem("student")).id;

//                     const paymentData = {
//                         orderCreationId: data.id,
//                         razorpayPaymentId: response.razorpay_payment_id,
//                         razorpayOrderId: response.razorpay_order_id,
//                         razorpaySignature: response.razorpay_signature,
//                         courses: cart,
//                         studentId
//                     };

//                     // Log the payment data before sending
//                     console.log("Payment Data:", paymentData);

//                     try {
//                         const response = await axios.post(VERIFY_PAYMENT, paymentData);
//                         // emptyCart(); // Clear the cart after successful payment
//                         console.log("Payment verification response:", response);
//                         if (response?.status === 200) {
//                             toast.success("Payment successful!");

//                             emptyCart();

//                         }
//                         // alert(data.msg);
//                     } catch (verificationError) {
//                         console.error("Payment verification failed:", verificationError);
//                         toast.error("Payment verification failed. Please contact support.");
//                     }
//                 },
//                 prefill: {
//                     name: student?.firstName + " " + student?.lastName,
//                     email: student?.email,
//                     contact: student?.mobile,
//                 },
//                 theme: {
//                     color: "#3399cc",
//                 },
//             };

//             // Step 5: Open Razorpay checkout
//             const razorpay = new window.Razorpay(options);
//             razorpay.open();
//         } catch (error) {
//             console.error("Payment Failed:", error);
//             toast.error("Payment Failed . Please try again.");
//         } finally {
//             setLoading(false);
//         }
//     };

//     useEffect(() => {
//         // Check if 'student' exists in localStorage
//         const student = localStorage.getItem('student');

//         // If 'student' is not found, navigate to the login page
//         if (!student) {
//             navigate('/login');
//         }
//     }, [navigate]);

//     return (
//         <Layout>

//             <Container>
//                 <Row className="mt-5">
//                     <Col md={8}>
//                         <h2>Your Cart</h2>
//                         {cart.length === 0 ? (
//                             <h4 style={styles.emptyCartMessage}>Your cart is empty!</h4>
//                         ) : (
//                             <>
//                                 <Table style={styles.cartTable}>
//                                     <thead>
//                                         <tr>
//                                             <th>Course</th>
//                                             <th>Price</th>
//                                             <th>Actions</th>
//                                         </tr>
//                                     </thead>
//                                     <tbody>
//                                         {cart.map((item) => (
//                                             <tr key={item.id}>
//                                                 <td>{item.title}</td>
//                                                 <td>₹{item.price}</td>

//                                                 <td>
//                                                     <Button
//                                                         style={styles.removeButton}
//                                                         onClick={() => removeFromCart(item.id)}
//                                                     >
//                                                         Remove
//                                                     </Button>
//                                                 </td>
//                                             </tr>
//                                         ))}
//                                     </tbody>
//                                 </Table>

//                                 <div style={styles.cartSummary}>
//                                     <h4>Total: ₹{total.toFixed(2)}</h4>
//                                     <div className="d-flex justify-content-between">
//                                         <Button color="danger" onClick={emptyCart} style={styles.emptyCartButton}>
//                                             Empty Cart
//                                         </Button>
//                                         <Button
//                                             color="primary"
//                                             onClick={handleCheckout}
//                                             disabled={loading}
//                                             style={styles.checkoutButton}
//                                         >
//                                             {loading ? 'Processing...' : 'Proceed to Checkout'}
//                                         </Button>
//                                     </div>
//                                 </div>
//                             </>
//                         )}
//                     </Col>
//                     <Col md={4}>
//                         <h3>Cart Summary</h3>
//                         <div style={styles.cartSummary}>
//                             <h4>Total Items: {cart.length}</h4>
//                             <h4>Total Price: ₹{total.toFixed(2)}</h4>
//                             <Button
//                                 color="success"
//                                 block
//                                 onClick={handleCheckout}
//                                 style={styles.checkoutButton}
//                                 disabled={cart.length === 0}
//                             >
//                                 Checkout
//                             </Button>
//                         </div>
//                     </Col>
//                 </Row>
//             </Container>

//         </Layout>
//     );
// };

// const styles = {
//     cartTable: {
//         width: '100%',
//         marginBottom: '30px',
//         border: '1px solid #ddd',
//     },
//     quantityInput: {
//         width: '60px',
//         padding: '5px',
//         textAlign: 'center',
//     },
//     removeButton: {
//         backgroundColor: '#dc3545',
//         borderColor: '#dc3545',
//     },
//     cartSummary: {
//         padding: '20px',
//         backgroundColor: '#f8f9fa',
//         borderRadius: '8px',
//         boxShadow: '0px 2px 5px rgba(0, 0, 0, 0.1)',
//         marginTop: '20px',
//     },
//     emptyCartButton: {
//         backgroundColor: '#dc3545',
//         borderColor: '#dc3545',
//     },
//     checkoutButton: {
//         backgroundColor: '#007bff',
//         borderColor: '#007bff',
//     },
//     emptyCartMessage: {
//         textAlign: 'center',
//         color: '#6c757d',
//         fontStyle: 'italic',
//     },
// };
// export default Cart;












import React, { useEffect, useState } from 'react';
import { Button, Table, Container, Row, Col, Alert, Spinner } from 'reactstrap';
import Layout from '../component/layout/Layout';
import { useCart } from '../context/CardContext';
import { CREATE_ORDER, VERIFY_PAYMENT, ENROLL_FREE_COURSE } from '../helper/url_helper';
import axios from 'axios';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

const Cart = () => {
    const { cart, total, removeFromCart, emptyCart } = useCart();
    const [loading, setLoading] = useState(false);
    const [processingFreeCourse, setProcessingFreeCourse] = useState(false);
    const navigate = useNavigate();

    // Check if cart contains only free courses
    const isFreeCart = total === 0 && cart.length > 0;
    const hasFreeItems = cart.some(item => item.price === 0);
    const hasPaidItems = cart.some(item => item.price > 0);

    // Handle enrollment for free courses
    const enrollFreeCourses = async () => {
        setProcessingFreeCourse(true);

        try {
            // Check student login
            const studentStr = localStorage.getItem("student");
            if (!studentStr) {
                toast.error("Please login to enroll in courses");
                navigate('/login');
                return;
            }

            const student = JSON.parse(studentStr);
            const studentId = student.id;

            const freeCourses = cart.filter(item => item.price === 0);

            if (freeCourses.length === 0) {
                toast.info("No free courses to enroll");
                setProcessingFreeCourse(false);
                return;
            }

            let successfulEnrollments = 0;
            const failedEnrollments = [];

            // Process each free course
            for (const item of freeCourses) {
                try {
                    // Use course organization or default to 1
                    const courseOrgId = item.organizationId || 1;

                    const response = await axios.get(
                        `${ENROLL_FREE_COURSE}/${studentId}/${item.id}`,
                        {
                            headers: {
                                'Content-Type': 'application/json',
                                'X-Organization-ID': courseOrgId
                            }
                        }
                    );

                    const responseData = response.data;

                    if (responseData.success === true) {
                        successfulEnrollments++;
                        removeFromCart(item.id);
                    } else {
                        failedEnrollments.push({
                            title: item.title,
                            error: responseData.message
                        });
                    }

                } catch (error) {
                    failedEnrollments.push({
                        title: item.title,
                        error: 'Network error'
                    });
                }

                // Small delay between requests
                await new Promise(resolve => setTimeout(resolve, 300));
            }

            // Show results
            if (successfulEnrollments > 0) {
                toast.success(`Successfully enrolled in ${successfulEnrollments} course(s)!`);

                // Redirect to My Courses
                setTimeout(() => {
                    navigate('/my-courses');
                }, 1500);

            } else if (failedEnrollments.length > 0) {
                toast.error("Unable to enroll in courses at this time");
            }

        } catch (error) {
            toast.error("An error occurred during enrollment");
        } finally {
            setProcessingFreeCourse(false);
        }
    };

    const handleCheckout = async () => {
        // If cart is completely free, handle free enrollment
        if (isFreeCart) {
            await enrollFreeCourses();
            return;
        }

        setLoading(true);

        const loadRazorpayScript = () => {
            return new Promise((resolve, reject) => {
                if (window.Razorpay) {
                    resolve(true);
                    return;
                }
                const script = document.createElement("script");
                script.src = "https://checkout.razorpay.com/v1/checkout.js";
                script.onload = () => resolve(true);
                script.onerror = () => reject(new Error("Unable to load payment gateway"));
                document.body.appendChild(script);
            });
        };

        try {
            await loadRazorpayScript();

            const amount = total;

            // Validate minimum amount for Razorpay
            if (amount < 1) {
                toast.error("Minimum payment amount is ₹1");
                setLoading(false);
                return;
            }

            const response = await axios.post(CREATE_ORDER, { amount });

            const student = JSON.parse(localStorage.getItem("student"));
            const data = response.data;

            const options = {
                key: process.env.REACT_APP_RAZORPAY_KEY || "rzp_live_S8tMzhDAvY5iJR",
                amount: data.amount,
                currency: "INR",
                name: "Amass Skill Ventures",
                description: "Payment for courses",
                order_id: data.id,
                handler: async (paymentResponse) => {
                    const studentId = JSON.parse(localStorage.getItem("student")).id;

                    const paymentData = {
                        orderCreationId: data.id,
                        razorpayPaymentId: paymentResponse.razorpay_payment_id,
                        razorpayOrderId: paymentResponse.razorpay_order_id,
                        razorpaySignature: paymentResponse.razorpay_signature,
                        courses: cart.filter(item => item.price > 0),
                        studentId
                    };

                    try {
                        await axios.post(VERIFY_PAYMENT, paymentData);

                        // Also enroll any free courses in the cart
                        const freeCourses = cart.filter(item => item.price === 0);
                        if (freeCourses.length > 0) {
                            await enrollFreeCourses();
                        }

                        toast.success("Payment successful! Courses have been added to your account.");
                        emptyCart();

                        setTimeout(() => {
                            navigate('/my-courses');
                        }, 1500);

                    } catch (verificationError) {
                        toast.error("Payment verification failed. Please contact support.");
                    }
                },
                prefill: {
                    name: student?.firstName + " " + student?.lastName,
                    email: student?.email,
                    contact: student?.mobile,
                },
                theme: {
                    color: "#3399cc",
                },
                modal: {
                    ondismiss: () => {
                        toast.info("Payment cancelled");
                        setLoading(false);
                    }
                }
            };

            const razorpay = new window.Razorpay(options);
            razorpay.open();

        } catch (error) {
            if (error.response?.data?.message?.includes?.("minimum amount") ||
                error.message?.includes?.("minimum amount")) {
                toast.info("Processing as free enrollment...");
                await enrollFreeCourses();
            } else {
                toast.error("Payment processing failed. Please try again.");
            }
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        const student = localStorage.getItem('student');
        if (!student) {
            navigate('/login');
        }
    }, [navigate]);

    return (
        <Layout>
            <Container className="py-5">
                <Row>
                    <Col lg={8}>
                        <h2 className="mb-4">Your Shopping Cart</h2>

                        {isFreeCart && cart.length > 0 && (
                            <Alert color="success" className="mb-4">
                                <h5 className="alert-heading">🎉 Free Courses Available!</h5>
                                <p className="mb-0">These courses are completely free. Click "Enroll Now" to get instant access.</p>
                            </Alert>
                        )}

                        {hasFreeItems && hasPaidItems && (
                            <Alert color="info" className="mb-4">
                                <h5 className="alert-heading">Mixed Cart</h5>
                                <p className="mb-0">You have both free and paid courses. Free courses will be enrolled automatically after payment.</p>
                            </Alert>
                        )}

                        {cart.length === 0 ? (
                            <div className="text-center py-5">
                                <div className="mb-4">
                                    <i className="bi bi-cart-x display-1 text-muted"></i>
                                </div>
                                <h4 className="text-muted mb-4">Your cart is empty</h4>
                                <Button
                                    color="primary"
                                    onClick={() => navigate('/courses')}
                                    size="lg"
                                >
                                    Browse Courses
                                </Button>
                            </div>
                        ) : (
                            <>
                                <div className="card shadow-sm mb-4">
                                    <div className="card-body p-0">
                                        <Table responsive hover className="mb-0">
                                            <thead className="bg-light">
                                                <tr>
                                                    <th className="border-0">Course</th>
                                                    <th className="border-0 text-center">Price</th>
                                                    <th className="border-0 text-center">Actions</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {cart.map((item) => (
                                                    <tr key={item.id}>
                                                        <td>
                                                            <div className="d-flex align-items-center">
                                                                <div className="flex-grow-1 ms-3">
                                                                    <h6 className="mb-1">{item.title}</h6>
                                                                    {item.shortDescription && (
                                                                        <p className="text-muted small mb-0">{item.shortDescription}</p>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td className="align-middle text-center">
                                                            {item.price === 0 ? (
                                                                <span className="badge bg-success fs-6">FREE</span>
                                                            ) : (
                                                                <span className="h5 mb-0">₹{item.price}</span>
                                                            )}
                                                        </td>
                                                        <td className="align-middle text-center">
                                                            <Button
                                                                color="outline-danger"
                                                                size="sm"
                                                                onClick={() => removeFromCart(item.id)}
                                                                disabled={processingFreeCourse}
                                                            >
                                                                Remove
                                                            </Button>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </Table>
                                    </div>
                                </div>

                                <div className="card shadow-sm">
                                    <div className="card-body">
                                        <div className="d-flex justify-content-between align-items-center mb-4">
                                            <h4 className="mb-0">Total: ₹{total.toFixed(2)}</h4>
                                            {total === 0 && cart.length > 0 && (
                                                <span className="badge bg-success bg-opacity-10 text-success fs-6">
                                                    All courses are free!
                                                </span>
                                            )}
                                        </div>

                                        <div className="d-flex justify-content-between">
                                            <Button
                                                color="outline-secondary"
                                                onClick={emptyCart}
                                                disabled={processingFreeCourse}
                                            >
                                                Clear Cart
                                            </Button>
                                            <Button
                                                color={isFreeCart ? "success" : "primary"}
                                                onClick={handleCheckout}
                                                disabled={loading || processingFreeCourse}
                                                size="lg"
                                            >
                                                {loading || processingFreeCourse ? (
                                                    <>
                                                        <Spinner size="sm" className="me-2" />
                                                        {loading ? 'Processing...' : 'Enrolling...'}
                                                    </>
                                                ) : isFreeCart ? (
                                                    'Enroll Now (Free)'
                                                ) : (
                                                    'Proceed to Checkout'
                                                )}
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                            </>
                        )}
                    </Col>

                    <Col lg={4}>
                        <div className="card shadow-sm sticky-top" style={{ top: '20px' }}>
                            <div className="card-body">
                                <h4 className="card-title mb-4">Order Summary</h4>

                                <div className="mb-4">
                                    <div className="d-flex justify-content-between mb-2">
                                        <span className="text-muted">Items ({cart.length})</span>
                                        <span>₹{total.toFixed(2)}</span>
                                    </div>

                                    {hasFreeItems && (
                                        <div className="alert alert-success py-2 mb-3">
                                            <div className="d-flex justify-content-between align-items-center">
                                                <span>Free Courses</span>
                                                <span className="badge bg-success">
                                                    {cart.filter(item => item.price === 0).length}
                                                </span>
                                            </div>
                                        </div>
                                    )}

                                    {hasPaidItems && (
                                        <div className="alert alert-info py-2 mb-3">
                                            <div className="d-flex justify-content-between align-items-center">
                                                <span>Paid Courses</span>
                                                <span>₹{cart
                                                    .filter(item => item.price > 0)
                                                    .reduce((sum, item) => sum + item.price, 0)
                                                    .toFixed(2)}
                                                </span>
                                            </div>
                                        </div>
                                    )}
                                </div>

                                <div className="border-top pt-3">
                                    <div className="d-flex justify-content-between mb-3">
                                        <h5>Total Amount</h5>
                                        <h5 className="text-primary">₹{total.toFixed(2)}</h5>
                                    </div>

                                    <Button
                                        color={isFreeCart ? "success" : "primary"}
                                        className="w-100 py-3"
                                        onClick={handleCheckout}
                                        disabled={cart.length === 0 || loading || processingFreeCourse}
                                        size="lg"
                                    >
                                        {loading || processingFreeCourse ? (
                                            <>
                                                <Spinner size="sm" className="me-2" />
                                                {loading ? 'Processing...' : 'Enrolling...'}
                                            </>
                                        ) : isFreeCart ? (
                                            'Enroll All Free Courses'
                                        ) : (
                                            'Secure Checkout'
                                        )}
                                    </Button>

                                    {isFreeCart && cart.length > 0 && (
                                        <p className="text-center text-muted small mt-3 mb-0">
                                            <i className="bi bi-shield-check me-1"></i>
                                            Instant access to all enrolled courses
                                        </p>
                                    )}
                                </div>

                                {cart.length > 0 && (
                                    <div className="mt-4">
                                        <div className="alert alert-light border">
                                            <h6 className="alert-heading fs-6 mb-2">
                                                <i className="bi bi-info-circle me-2"></i>
                                                Need help?
                                            </h6>
                                            <p className="small mb-0">
                                                Contact support at{' '}
                                                <a href="tel:+919484794843" className="text-decoration-none">
                                                    +91 94847 94843
                                                </a>
                                            </p>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </Layout>
    );
};

export default Cart;


